import { render, staticRenderFns } from "./AdminDataHeader.vue?vue&type=template&id=22d42455&scoped=true"
import script from "./AdminDataHeader.vue?vue&type=script&lang=js"
export * from "./AdminDataHeader.vue?vue&type=script&lang=js"
import style0 from "./AdminDataHeader.vue?vue&type=style&index=0&id=22d42455&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d42455",
  null
  
)

export default component.exports